"use client";

import { useEffect, useState } from "react";
import { EnvService } from "@/services/Environment/Environment";

/**
 * Reactive `useIsLocalEnv`. Reads `DEPLOYMENT_ENV` from `EnvService` and
 * returns `true` when it equals `"local"`. Falls back to `false` while the
 * env cache is still being populated by `EnvService.init()` in providers,
 * then flips on once it's ready.
 */
export function useIsLocalEnv(): boolean {
  const [value, setValue] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const check = (): boolean => {
      const env = EnvService.getVar("DEPLOYMENT_ENV");
      if (env === undefined) return false;
      if (!cancelled) setValue(env === "local");
      return true;
    };
    if (check()) return;
    const interval = setInterval(() => {
      if (check()) clearInterval(interval);
    }, 100);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  return value;
}
